import {
  Dispatch,
  FC,
  MouseEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useNavigate, useLocation, useParams, createPath, NavigateFunction, To } from 'react-router';
import { connect, ConnectedProps, useDispatch, useSelector } from 'react-redux';
import { ResizeCallbackData } from 'react-resizable';
import PageHeader from 'Components/UI/PageHeader/PageHeader';
import BreadCrumb, { IBreadcrumbItem } from 'Components/UI/BreadCrumb';
import Table from 'Components/UI/Table';
import TableActionTopbar from 'Components/UI/TableActionTopbar';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { ListagemArquivosActions } from 'Store/ListagemArquivos/ListagemArquivos.actions';
import emptyListImage from 'Static/images/computer-upload.png';
import { useTimeout } from 'Context/TimeoutContext';
import {
  getColumnsTable,
  IRequestPlotColumns,
  getBreadCrumbDefault,
  IResizableColumnProps,
  RESIZABLE_COLUMN_IDS,
  getBreadCrumb,
  getColumnsTableEdit
} from './ListagemArquivos.columns';
import {
  changeStatusFiles,
  getButtonsTableToolbar,
  getResizableColumnStorageKey,
  getResizableColumnWidth,
  handleOpenFileLink,
  getAutodeskViewerPath,
  minWidthResizableColumns,
  SELECTION_COLUMN_WIDTH,
  handleOpenForgeViewer,
  renameFile,
  saveOrderList,
  updateUploadState,
  handleOpenCoordly2DViewer,
  getCoordly2DViewerPath,
  handleOpenCoordly3DViewer,
  getCoordly3DViewerPath,
  openFolder,
} from './ListagemArquivos.helpers';
import FileDrop from 'Components/UI/FileDrop';
import { Http } from 'Utils/Http';
import ExclusaoArquivos, {
  IDeleteFilesComponentRequest,
} from './Modals/ExclusaoArquivos';
import NovaPasta from './Modals/NovaPasta';
import AvisoTamanhoEQuantidadeArquivos from './Modals/AvisoTamanhoEQuantidadeArquivos';
import { ICreateFolderRequest } from '../../Data/interfaces/Obra/ICreateFolder';
import SolicitacaoPlotagem from './SolicitacaoPlotagem';
import { IUnarchiveFilesRequest } from 'Data/interfaces/Obra/IUnarchiveFilesRequest';
import ViewerSignalR from 'Components/UI/SignalR/viewer';
import { mapNotification, getDisciplineDisplayIcon } from 'Utils/ObraUtils';
import UpdateStatus from 'Components/UI/UpdateStatusList';
import DownloadModal from 'Components/UI/ModalDownload';
import AvisoRenderizacaoUpgrade from 'Components/UI/AvisoRenderizacaoUpgrade';
import LoadingArchives from 'Components/UI/CustomLoading/LoadingArchives';
import { BucketFileStatusEnum, IBreadCrumbItem, FileStatusEnum, IFileData } from 'Data/interfaces/ListagemArquivos/IListFilesResponse';
import EdicaoNomenclatura from './Components/EdicaoNomenclatura/EdicaoNomenclatura';
import AppStorage from 'Utils/AppStorage';
import { ViewerActions } from 'Store/Viewer/Viewer.actions';
import { fileDataSizeToBytes } from 'Utils/toolBox';
import { ConfigProvider, Empty } from 'antd';
import CustomEmptyData from 'Components/UI/CustomEmptyData';
import TabsShell, { PathActiveEnum } from 'Components/UI/TabsShell';
import { ObraActions } from 'Store/Obra/Obra.actions';
import DownloadBloqueadosModal, { IBlockedParams } from './Modals/DownloadBloqueadosModal';
import { IDownloadFilesRequest } from 'Data/interfaces/Obra/IDownloadFilesRequest';
import VisualizacaoBloqueadosModal from './Modals/VisualizacaoBloqueadosModal';
import AvisoUploadUpgrade from './Modals/AvisoUploadUpgrade';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';
import { Mixpanel } from 'Utils/MixPanel';
import useWindowSize from 'Hooks/useWindowSize';
import { getCurrentTenant, getTenants } from 'Store/Tenant/Tenant.selector';
import { HistoryActions } from 'Store/History/History.actions';
import { IHistoryFileRequestList } from 'Data/interfaces/History/IHistoryFileApi';
import { UploadActions } from 'Store/Upload/Upload.actions';
import NewEdicaoNomenclatura from './Components/NewEdicaoNomenclatura/NewEdicaoNomenclatura';
import toastHandler from 'Utils/toastHandler';
import { useQueryInAppObraNotifications } from 'Hooks/notifications/useQueryInAppObraNotifications';
import {
  INotificationInAppObra,
  INotificationMultipleReadRequest,
} from 'Data/interfaces/Notification/INotification';
import { IFileRenameData } from 'Data/interfaces/ListagemArquivos/IFileRenameRequest';
import { setFileStatusRendering, useQueryFiles } from 'Hooks/files/useQueryFiles';
import { resetFileStatusRendering } from 'Hooks/files/useQueryVerifyAutodeskProfressFiles';
import { useQueryRenderViewerFile } from 'Hooks/files/useQueryRenderViewerFile';
import { ViewerEngineEnum } from 'Data/enums/ViewerEngine';
import {
  asAutodeskConversion,
  autodeskStatusOf,
  isNativeReady,
  nativeStatusOf,
  ViewerEngineName,
} from 'Data/interfaces/Viewer/INativeViewerArtifacts';
import i18n from 'i18n';
import { useQueryUniqueObra } from 'Hooks/obras/useQueryUniqueObra';
import { IListFilesOrder, IListFilesOrderKey } from 'Data/interfaces/ListagemArquivos/ISortListFiles';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import { useQueryRenameFiles } from 'Hooks/files/useQueryRenameFiles';
import { useQueryCreateFolderFiles } from 'Hooks/files/useQueryCreateFolderFiles';
import { useNotification } from 'Context/NotificationContext';
import { IContextMenuRef } from 'Components/UI/ContextMenu/model';
import ContextMenu from 'Components/UI/ContextMenu';
import MoreActionsDropdownContent, { IOpenFileOptions } from './Components/MoreActionsDropdownContent';
import MoveFilesModal from './Modals/MoveFilesModal';
import ViewerNativoIndisponivelModal from './Modals/ViewerNativoIndisponivelModal';
import ProgressRenderBar from './Modals/ProgressRenderBar';
import {
  extensions2dAnd3d,
  useCoordlyViewerFeature,
  useCoordly3DViewerFeature,
  COORDLY_3D_VIEWER_EXTENSION,
  loadRenderQuota,
  IRenderQuota,
  renderQuotaBar,
  isLimitedResourcesError,
  isNativeEngineUnavailableError,
  markAutodeskConversionConfirmed,
} from 'Utils/ViewerUtils';
import AccessPermission from 'Utils/AcessPermission';
import { useQueryUpdateInfoFiles } from 'Hooks/files/useQueryUpdateInfoFiles';
import { useQueryUpdateFilesStatus } from 'Hooks/files/useQueryUpdateFilesStatus';
import { useQueryUnarchiveFiles } from 'Hooks/files/useQueryUnarchiveFiles';
import { IUpdateFileInfo } from 'Data/interfaces/Obra/IUpdateFileInfoRequest';
import dayjs from 'dayjs';
import styles from './ListagemArquivos.module.scss';
import './ListagemArquivos-override.css';

export const RELOAD_LISTAGEM_ARQUIVOS_KEY = 'RELOAD_LISTAGEM_ARQUIVOS_KEY';

const defaultOrder: IListFilesOrder = {
  last: null,
  name: null,
  extension: null,
  sizeInBytes: null,
  revision: null,
  lastUpdate: null,
  status: null,
};

export interface IOpenMoreActionsDropdown {
  open: boolean;
  id: string | null;
}

export interface IOpenFileAction {
  csId: number;
  ConstructionSiteDisciplinesId: number;
  record: IFileData;
  constructionSiteName: string;
  breadCrumbId: number | string;
  constructionSiteApiId: number;
  event: number;
  dispatch: Dispatch<any>;
}

export interface IOpenVisualizationBlockedFileAction {
  path: string;
  newWindown: boolean;
  /** Abertura depois do aviso, quando ainda falta outra etapa (ex.: aceite do token). */
  onConfirm?: () => void;
}

const ListagemArquivos: FC<Props> = ({
  filters,
  selectedEditRowKeys,
  showEditTable,
  showPlotRequestTable,
  nomenclature,
  editFormIndex,
  isLoading,
  isDownloading,
  showModalDeleteFiles,
  showModalCreateFolder,
  showModalInfoFiles,
  notificationsMapOld,
  userInfo,
  planFree,
  userLimitsActive,
  openLink,
  currentUserPrivileges,
  isShellCollapsed,
  error,
}) => {
  const downloadViaStreamFlag = useFeatureFlag('download-via-stream');
  const downloadViaStream = downloadViaStreamFlag.enabled && downloadViaStreamFlag.value === 'test';
  const stagesFeatureValidateFlag = useFeatureFlag('stages-feature-validate');
  const stagesFeatureValidate = stagesFeatureValidateFlag.enabled && stagesFeatureValidateFlag.value === 'test';
  const followFolderFeatureFlag = useFeatureFlag('follow-folder-feature');
  const followFolderFeature = followFolderFeatureFlag.enabled && followFolderFeatureFlag.value === 'test';

  const dispatch = useDispatch();
  const { set, clear } = useTimeout();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { height, width } = useWindowSize();
  const {
    data: inAppNotifications,
  } = useQueryInAppObraNotifications(Number(params.constructionSiteId));
  const { addNotificationsToRead } = useNotification();

  const currentTenant = useSelector(getCurrentTenant);
  const tenants = useSelector(getTenants);
  const hasCheckedReload = useRef(false);
  const [dynamicIgnoreCache, setDynamicIgnoreCache] = useState(false);
  const breadCrumbId = Http.GetQueryParams('breadCrumbId');
  const onlyFolder = Http.GetQueryParams('onlyFolder');
  const isObsoleteFolder = Http.GetQueryParams('isObsoleteFolder') === 'true';
  const folderName = Http.GetQueryParams('folderName');
  const obraApi = Http.GetQueryParams('obraApi');
  const ignoreCache = Http.GetQueryParams('ignoreCache');
  const ConstructionSiteDisciplinesId = Number(
    Http.GetQueryParams('ConstructionSiteDisciplinesId'),
  );
  const DisciplineName = Http.GetQueryParams('DisciplineName');
  const request = useMemo(() => {
    const result: any = { ...params };
    if (breadCrumbId) {
      result['breadCrumbId'] = breadCrumbId;
    }
    if (onlyFolder) {
      result['onlyFolder'] = onlyFolder;
    }
    if (isObsoleteFolder) {
      result['isObsoleteFiles'] = isObsoleteFolder;
    }
    if (folderName) {
      result['folderName'] = folderName;
    }
    if (obraApi) {
      result['api'] = obraApi;
    }
    if (userInfo) {
      result['userInfoTracking'] = userInfo;
    }
    if (currentTenant) {
      result['currentTenantTracking'] = currentTenant;
    }
    let reloadIgnoreCache = false;
    if (!hasCheckedReload.current) {
      if (!(window as any)[RELOAD_LISTAGEM_ARQUIVOS_KEY]) {
        reloadIgnoreCache = true;
        (window as any)[RELOAD_LISTAGEM_ARQUIVOS_KEY] = true;
      }
      hasCheckedReload.current = true;
    }
    if (ignoreCache || reloadIgnoreCache || dynamicIgnoreCache) {
      result['ignoreCache'] = true;
    }
    if (tenants) {
      result['tenantIds'] = tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined);
    }
    return result;
  }, [
    breadCrumbId,
    folderName,
    isObsoleteFolder,
    params,
    obraApi,
    onlyFolder,
    currentTenant,
    userInfo,
    tenants,
    ignoreCache,
    dynamicIgnoreCache,
  ]);
  const {
    data: filesData,
    isFetching: isLoadingFileList,
    refetch: refetchFilesData,
  } = useQueryFiles(request);
  const {
    data: obra,
  } = useQueryUniqueObra({ csId: Number(params.constructionSiteId), navigate });
  const { renameFiles, isLoading: isLoadingRenameFile } = useQueryRenameFiles();
  const { createFolderFiles, isLoading: isLoadingCreateFolder } = useQueryCreateFolderFiles();
  const { updateInfoFiles } = useQueryUpdateInfoFiles();
  const { updateFilesStatus } = useQueryUpdateFilesStatus();
  const { unarchiveFiles } = useQueryUnarchiveFiles();

  const firstOpen = useRef(0);
  const contextMenuRef = useRef<IContextMenuRef>(null);
  const initializeLoadingCheckNotifications = useRef(false);
  const [breadCrumbs, setBreadCrumbs] = useState<IBreadcrumbItem[]>([]);
  const [isFileListRequest, setIsFileListRequest] = useState(false);
  const [showModalRenderUpgrade, setShowModalRenderUpgrade] = useState(false);
  const [downloadBlockedFile, setDownloadBlockedFile] = useState<IFileData | null>(null);
  const [showModalDownloadBlockedFiles, setShowModalDownloadBlockedFiles] = useState(
    false,
  );
  const [showModalUpgradeUpload, setShowModalUpgradeUpload] = useState(false);
  // Arquivo que o nosso viewer 3D não abre e espera a escolha do usuário pela Autodesk.
  const [nativeUnavailable, setNativeUnavailable] = useState<{
    file: IFileData;
    noWebGPU?: boolean;
    newTab?: boolean;
  } | null>(null);
  // Conversão Autodesk à espera do aceite do gasto (clique ou nova guia).
  const [confirmAutodesk, setConfirmAutodesk] = useState<{
    quota: IRenderQuota;
    onConfirm: () => void;
  } | null>(null);
  // Antes de cada conversão Autodesk: cota esgotada abre o mesmo modal do
  // LIMITED_RESOURCES e nem chama o Render.
  const confirmAutodeskConversion = async (file: IFileData, onConfirm: () => void, accepted?: boolean) => {
    const quota = await loadRenderQuota(file.Name);
    if (!quota.hasResource) { return setShowModalRenderUpgrade(true); }
    if (accepted) { return onConfirm(); }
    setConfirmAutodesk({ quota, onConfirm });
  };
  const { isCoordly2DViewerEligible } = useCoordlyViewerFeature();
  const { decideCoordly3D, isCoordly3DViewerEligible } = useCoordly3DViewerFeature();
  const { mutate: renderViewerFile } = useQueryRenderViewerFile();
  const [
    showModalVisualizationBlockedFiles,
    setShowModalVisualizationBlockedFiles,
  ] = useState(false);
  const [
    hasPermissionVisualizationBlockedFiles,
    setHasPermissionVisualizationBlockedFiles,
  ] = useState(false);
  const [openFileVisualizationLinkStatus, setOpenFileVisualizationLinkStatus] = useState(
    {} as IOpenVisualizationBlockedFileAction,
  );
  const [blockedParams, setBlockedParams] = useState<IBlockedParams>({
    hasPermission: false,
    isBlocked: false,
    hasBlockedFolders: false,
    hasMultipleFiles: false,
  });
  const [activeRow, setActiveRow] = useState<string[]>([]);
  const [searchArchives, setSearchArchives] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<IFileData[]>([]);
  const [deleteFilesRequest, setDeleteFilesRequest] = useState(
    {} as IDeleteFilesComponentRequest,
  );
  const [editFolder, setEditFolder] = useState<IFileData | null>(null);
  const [order, setOrder] = useState<IListFilesOrder>(defaultOrder);

  const itemIdNotification = mapNotification(notificationsMapOld, true);
  const filterNotification = mapNotification(notificationsMapOld);
  const requestPlotListFiles: IRequestPlotColumns[] = filesData.ListFiles.filter((file) =>
    selectedEditRowKeys.includes(file.Identifier.ApiId || file.Identifier.ItemId),
  )
    .filter((file: any) => file.Status !== 0)
    .map((file: any, index: number) => ({
      Name: file?.Name,
      HasColor: false,
      Extension: file?.Extension,
      key: index,
      FileInfoFk: file?.FileInfo?.FileInfoId || null,
      FileApiId: file?.FileInfo?.ApiId || null,
    }));
  const [openMoreActionsDropdown, setOpenMoreActionsDropdown] = useState<IOpenMoreActionsDropdown>({
    open: false,
    id: null,
  });
  const [contextMenuRecord, setContextMenuRecord] = useState<IFileData | null>(null);
  const [showMoveFilesModal, setShowMoveFilesModal] = useState(false);
  const [newFolderWithDestination, setNewFolderWithDestination] = useState<string | null>(null);
  const [canReadNow, setCanReadNow] = useState(false);
  const firstRender = useRef(true);
  const firstTableWidth = useRef(0);
  const [columnsWidth, setColumnsWidth] = useState<IResizableColumnProps>({
    active: false,
    columnWidth: {
      [RESIZABLE_COLUMN_IDS.Name]: minWidthResizableColumns[RESIZABLE_COLUMN_IDS.Name],
      [RESIZABLE_COLUMN_IDS.Extension]: minWidthResizableColumns[RESIZABLE_COLUMN_IDS.Extension],
      [RESIZABLE_COLUMN_IDS.SizeInBytes]: minWidthResizableColumns[RESIZABLE_COLUMN_IDS.SizeInBytes],
      [RESIZABLE_COLUMN_IDS.RenderingStatus]: minWidthResizableColumns[RESIZABLE_COLUMN_IDS.RenderingStatus],
      [RESIZABLE_COLUMN_IDS.Versions]: minWidthResizableColumns[RESIZABLE_COLUMN_IDS.Versions],
      [RESIZABLE_COLUMN_IDS.LastUpdate]: minWidthResizableColumns[RESIZABLE_COLUMN_IDS.LastUpdate],
      [RESIZABLE_COLUMN_IDS.Status]: minWidthResizableColumns[RESIZABLE_COLUMN_IDS.Status],
      [RESIZABLE_COLUMN_IDS.Action]: minWidthResizableColumns[RESIZABLE_COLUMN_IDS.Action],
    }
  });
  const leftBarAndPaddingWidth = isShellCollapsed ? 132 : 307;
  const tableWidth = width - leftBarAndPaddingWidth;
  const tableHeight = height - 331;

  const displayColumnsWidth = useMemo(() => {
    const stored = columnsWidth.columnWidth;
    const flexId = RESIZABLE_COLUMN_IDS.Name;
    const result: Record<string, number> = {};
    let othersTotal = 0;
    Object.keys(stored).forEach((id) => {
      if (id === flexId) { return; }
      const minWidth = minWidthResizableColumns[id] ?? 0;
      const colWidth = Math.max(stored[id], minWidth);
      result[id] = colWidth;
      othersTotal += colWidth;
    });
    const freeSpace = tableWidth - SELECTION_COLUMN_WIDTH - othersTotal;
    result[flexId] = Math.max(
      minWidthResizableColumns[flexId] ?? 0,
      stored[flexId] ?? 0,
      freeSpace,
    );
    return result;
  }, [columnsWidth.columnWidth, tableWidth]);

  const scrollX = useMemo(() => {
    const columnsTotal = Object.values(displayColumnsWidth)
      .reduce((sum, w) => sum + w, 0);
    return columnsTotal + SELECTION_COLUMN_WIDTH;
  }, [displayColumnsWidth]);

  const notificationsObj = useMemo(() => {
    const foldersIds = [];
    const notificationsMap: Record<string, INotificationInAppObra[]> = {};
    for (const notification of inAppNotifications) {
      if (notification.ItemId in notificationsMap) {
        notificationsMap[notification.ItemId].push(notification);
      } else {
        notificationsMap[notification.ItemId] = [notification];
      }
      if (notification?.Folders?.length > 0) {
        foldersIds.push(...notification.Folders, notification.ItemId);
      }
    }
    return { foldersIds, notificationsMap };
  }, [inAppNotifications]);

  const handleResize = (columnId: string, data: ResizeCallbackData) => {
    setColumnsWidth(prev => {
      const newWidth = data.size.width;
      if (newWidth <= minWidthResizableColumns[columnId]) {
        return prev;
      }
      
      return {
        ...prev,
        active: true,
        columnWidth: {
          ...prev.columnWidth,
          [columnId]: newWidth,
        },
      };
    });
  };

  const resetResizableColumns = useCallback((clearStorage?: boolean) => {
    const resizableWidth = getResizableColumnWidth(tableWidth, followFolderFeature);
    setColumnsWidth(prev => {
      const newState = { ...prev };
      newState.active = false;
      newState.columnWidth = {
        [RESIZABLE_COLUMN_IDS.Name]: resizableWidth[RESIZABLE_COLUMN_IDS.Name],
        [RESIZABLE_COLUMN_IDS.Extension]: resizableWidth[RESIZABLE_COLUMN_IDS.Extension],
        [RESIZABLE_COLUMN_IDS.SizeInBytes]: resizableWidth[RESIZABLE_COLUMN_IDS.SizeInBytes],
        [RESIZABLE_COLUMN_IDS.RenderingStatus]: resizableWidth[RESIZABLE_COLUMN_IDS.RenderingStatus],
        [RESIZABLE_COLUMN_IDS.Versions]: resizableWidth[RESIZABLE_COLUMN_IDS.Versions],
        [RESIZABLE_COLUMN_IDS.LastUpdate]: resizableWidth[RESIZABLE_COLUMN_IDS.LastUpdate],
        [RESIZABLE_COLUMN_IDS.Status]: resizableWidth[RESIZABLE_COLUMN_IDS.Status],
        [RESIZABLE_COLUMN_IDS.Action]: resizableWidth[RESIZABLE_COLUMN_IDS.Action],
      };
      return newState;
    });

    if (clearStorage && !!userInfo?.Id && !!params.constructionSiteId) {
      clear('clear-resizable-columns-storage');
      set('clear-resizable-columns-storage', () => {
        const resizableStorageKey = getResizableColumnStorageKey(
          userInfo?.Id || '',
          Number(params.constructionSiteId)
        );
        AppStorage.RemoveItem(resizableStorageKey, 'local');
      }, 200);
    }
  }, [tableWidth, followFolderFeature, userInfo?.Id, params.constructionSiteId]);

  useEffect(() => {
    if (
      firstOpen.current === 0 &&
      obra?.Name &&
      DisciplineName &&
      obra.ConstructionSiteId === Number(params.constructionSiteId)
    ) {
      if (DisciplineName === folderName) {
        Mixpanel.track({
          name: 'PAGE_VIEW',
          props: {
            constructionSiteId: Number(params.constructionSiteId),
            disciplineId: ConstructionSiteDisciplinesId,
            disciplineApiFolderId: params.folderId,
            disciplineName: DisciplineName,
          },
          userInfo,
          currentListTenant: currentTenant,
          tenantIds: tenants && tenants.length > 0
            ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
            : undefined,
        });
      } else {
        Mixpanel.track({
          name: 'PAGE_VIEW',
          props: {
            constructionSiteId: Number(params.constructionSiteId),
            disciplineId: ConstructionSiteDisciplinesId,
            disciplineName: DisciplineName,
            folderId: params.folderId,
            folderName,
          },
          userInfo,
          currentListTenant: currentTenant,
          tenantIds: tenants && tenants.length > 0
            ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
            : undefined,
        });
      }
      firstOpen.current++;
    }
  }, [obra]);

  useEffect(() => {
    if (firstOpen.current <= 0 && AppStorage.GetItem('listFilesOrder')) {
      const listFilesSaveOrder = AppStorage.GetItem('listFilesOrder');
      if (listFilesSaveOrder) {
        setOrder(JSON.parse(listFilesSaveOrder) as IListFilesOrder);
      }
    }
    if (firstOpen.current > 0 && !!order.last) {
      saveOrderList(
        'listFilesOrder',
        order,
      );
    }
  }, [order]);

  useEffect(() => {
    if (isLoadingFileList && !isFileListRequest) {
      setIsFileListRequest(true);
    }
    setDynamicIgnoreCache(false);
  }, [isLoadingFileList]);

  useEffect(() => {
    dispatch(ListagemArquivosActions.setSelectedEditRowKeys([]));
    setSelectedFiles([]);
    dispatch(ViewerActions.setOpenFileLink(''));
    dispatch(UploadActions.checkUploadFilesInfoClear());

    return () => {
      clear('canReadNow');
      clear('REFETCH_FILES_DATA');
      clear('clear-resizable-columns-storage');
      firstRender.current = true;
      firstTableWidth.current = 0;
    };
  }, []);

  useEffect(() => {
    if (
      firstRender.current &&
      tableWidth > 0 &&
      userInfo?.Id &&
      params.constructionSiteId
    ) {
      const resizableStorageKey = getResizableColumnStorageKey(
        userInfo.Id,
        Number(params.constructionSiteId)
      );
      const storedColumnsWidth = AppStorage.GetItem(resizableStorageKey, 'local');
      if (!!storedColumnsWidth) {
        // Largura salva antes de um mínimo subir não pode ficar abaixo dele.
        const stored = JSON.parse(storedColumnsWidth);
        Object.keys(stored.columnWidth ?? {}).forEach(key => {
          stored.columnWidth[key] = Math.max(
            stored.columnWidth[key],
            minWidthResizableColumns[key] ?? 0,
          );
        });
        setColumnsWidth(stored);
      } else {
        resetResizableColumns();
      }
      firstRender.current = false;
      firstTableWidth.current = tableWidth;
    }

    if (
      !firstRender.current &&
      firstTableWidth.current !== tableWidth &&
      tableWidth > 0
    ) {
      if (columnsWidth.active) {
        const ratio = tableWidth / firstTableWidth.current;
        setColumnsWidth(prev => {
          const scaled = { ...prev, columnWidth: { ...prev.columnWidth } };
          Object.keys(scaled.columnWidth).forEach(key => {
            const newWidth = Math.round(prev.columnWidth[key] * ratio);
            scaled.columnWidth[key] = Math.max(
              newWidth,
              minWidthResizableColumns[key],
            );
          });
          return scaled;
        });
      } else {
        resetResizableColumns();
      }
      firstTableWidth.current = tableWidth;
    }

    return () => {
      if (columnsWidth.active && userInfo?.Id && params.constructionSiteId) {
        const resizableStorageKey = getResizableColumnStorageKey(
          userInfo.Id,
          Number(params.constructionSiteId)
        );
        AppStorage.SetItem(
          resizableStorageKey,
          JSON.stringify(columnsWidth),
          'local'
        );
      }
    };
  }, [
    columnsWidth,
    tableWidth,
    followFolderFeature,
    userInfo?.Id,
    params.constructionSiteId,
  ]);

  useEffect(() => {
    const pathname = location?.pathname || '';
    const search = location?.search;
    dispatch(
      ObraActions.storeArchivesPath({
        params,
        path: pathname,
        url: `${pathname}${search}`,
      }),
    );
  }, [params, location, dispatch]);

  useEffect(() => {
    if (filesData?.BreadCrumbItem) {
      if (isLoadingFileList || obra?.ConstructionSiteId === undefined) {
        setBreadCrumbs(getBreadCrumbDefault(filesData.BreadCrumbItem));
        dispatch(ListagemArquivosActions.setSelectedEditRowKeys([]));
      } else {
        setBreadCrumbs(
          getBreadCrumb(
            obra,
            filesData?.BreadCrumbItem,
            ConstructionSiteDisciplinesId,
            isObsoleteFolder,
          ),
        );
      }
    }
  }, [
    filesData,
    obra,
    isLoadingFileList,
    ConstructionSiteDisciplinesId,
    isObsoleteFolder,
  ]);

  useEffect(() => {
    if (!isLoadingRenameFile) {
      setActiveRow([]);
    }
  }, [isLoadingRenameFile]);

  useEffect(() => {
    if (
      !initializeLoadingCheckNotifications.current &&
      isLoading &&
      isLoadingFileList
    ) {
      initializeLoadingCheckNotifications.current = true;
      return;
    }

    // Marcar novas notificações como 'vistas'
    if (
      initializeLoadingCheckNotifications.current &&
      !error &&
      !isLoadingFileList &&
      !isLoading &&
      params?.constructionSiteId &&
      params?.folderId &&
      inAppNotifications &&
      inAppNotifications.length > 0 &&
      filesData.ListFiles &&
      filesData.ListFiles.length >= 0
    ) {
      if (!canReadNow) {
        clear('canReadNow');
        set('canReadNow', () => {
          setCanReadNow(true);
        }, 600);
      } else {
        const filesHasNotifications: INotificationInAppObra[] = [];
        const notificationAsView: INotificationMultipleReadRequest = {
          constructionSiteId: Number(params.constructionSiteId),
          itemAuxId: params.folderId,
          notificationIds: [],
        };
        for (const notification of inAppNotifications) {
          if (notification.Folders.length > 0) {
            const lastFolderId = notification.Folders[notification.Folders.length - 1];
            if (lastFolderId === params.folderId) {
              notificationAsView.notificationIds.push(notification.NotificationId);
            } else {
              const findFolderIndex = notification.Folders.findIndex((folder) => folder === params.folderId);
              if (findFolderIndex !== -1) {
                const afterFolder = notification.Folders[findFolderIndex + 1];
                if (afterFolder) {
                  const findFileIndex = filesData.ListFiles.findIndex((file) => file.Identifier.ApiId === afterFolder);
                  if (findFileIndex === -1) {
                    notificationAsView.notificationIds.push(notification.NotificationId);
                  }
                }
              }
            }
          }
          if (filesData.ListFiles.some((file) => file.Identifier.ApiId === notification.ItemId)) {
            filesHasNotifications.push(notification);
          }
        }
        for (const fileNotification of filesHasNotifications) {
          if (!notificationAsView.notificationIds.includes(fileNotification.NotificationId)) {
            notificationAsView.notificationIds.push(fileNotification.NotificationId);
          }
        }
        if (notificationAsView.notificationIds.length > 0) {
          addNotificationsToRead(
            params.folderId,
            notificationAsView,
          );
        }
      }
    }
  }, [
    filesData.ListFiles,
    isLoadingFileList,
    isLoading,
    inAppNotifications,
    params?.constructionSiteId,
    params?.folderId,
    addNotificationsToRead,
    canReadNow,
  ]);

  useEffect(() => {
    if (selectedEditRowKeys.length <= 1) {
      dispatch(
        ListagemArquivosActions.setShowModalDownloadMultipleFiles({ isVisible: false }),
      );
    }
  }, [selectedEditRowKeys]);

  const handleOpenMoreActionsDropdown = (id: string, open: boolean) => {
    if (!followFolderFeature) { return; }

    setOpenMoreActionsDropdown({
      open,
      id,
    });
  };

  const handleCloseMoreActionsDropdown = () => {
    setOpenMoreActionsDropdown({
      open: false,
      id: null,
    });
    handleCloseContextMenu();
  };

  const handleContextMenu = (e: MouseEvent, record: IFileData) => {
    setContextMenuRecord(record);
    contextMenuRef.current?.show(e);
  };
  const menuId = `ActionMenuObra${params?.folderId}`;

  const onChange = (selecteds: any, selectedsData: any) => {
    dispatch(ListagemArquivosActions.setSelectedEditRowKeys(selecteds));
    setSelectedFiles(selectedsData);
    handleCloseContextMenu();
  };

  const handleClearSelectedFiles = () => {
    dispatch(ListagemArquivosActions.setSelectedEditRowKeys([]));
    setSelectedFiles([]);
  };

  const rowSelection = {
    selectedRowKeys: selectedEditRowKeys,
    columnWidth: SELECTION_COLUMN_WIDTH,
    onChange,
  };

  const onSubmit = (values: any) => {
    let closable = true;
    let fullName = '';
    let nomenclatureCount = 0;
    let newName = '';

    if (obra?.VersionConfig?.VersionFields?.length) {
      nomenclatureCount = obra.VersionConfig.VersionFields.length - 1;
    }

    if (JSON.parse(`${values.hasNomenclatureControl}`)) {
      for (let i = 0; i <= nomenclatureCount; i++) {
        fullName += values[`field${i}`] + values[`separator${i}`];
      }
      newName = fullName.slice(0, -1) + '.' + values.extension;
    } else {
      newName = values.simpleFileName + '.' + values.extension;
    }

    if (
      values && filesData?.BreadCrumbItem &&
      !filesData.ListFiles.find((file: any) => file.Name === newName)
    ) {
      closable = false;
      renameFile(values, filesData?.BreadCrumbItem, (request) =>
        renameFiles(request, { onSuccess: () => setActiveRow([]) }),
      );
    }

    if (
      !filesData.ListFiles.find(
        (file: any) =>
          (file.Identifier.ApiId === values.fileId ||
            file.Identifier.ItemId === values.fileId) &&
          (file.FileInfo.Description === values.description ||
            (!file.FileInfo.Description && !values.description)),
      )
    ) {
      closable = false;
      const requestFiles: IUpdateFileInfo = {
        Api: values.api,
        ConstructionSiteFk: values.constructionSiteId,
        Description: values.description,
        ApiId: values.fileId,
        FileInfoId: values.fileInfoId,
        Status: values.status,
      };
      updateInfoFiles(
        {
          constructionSiteId: Number(params.constructionSiteId),
          folderId: params?.folderId || '',
          files: [requestFiles],
        },
        { onSuccess: () => setActiveRow([]) },
      );
    }

    if (closable) {
      setActiveRow([]);
    }
  };

  const onChangeNomenclatureInList = (record: any) => {
    setActiveRow((prevState: string[]) =>
      prevState[0] === (record.Identifier.ApiId || record.Identifier.ItemId)
        ? []
        : [record.Identifier.ApiId || record.Identifier.ItemId],
    );
  };

  const openModalExclusaoArquivos = (file?: IFileData | null) => {
    setDeleteFilesRequest({
      filesToDelete: file ? [file] : selectedFiles,
      FolderId: filesData?.BreadCrumbItem?.Identifier || '',
      ObsoleteFolderId: filesData?.ObsoleteFolderId,
      ConstructionSiteId: Number(params.constructionSiteId),
    });
    dispatch(ListagemArquivosActions.setShowModalDeleteFiles(true));
  };

  const closeModalExclusaoArquivos = () => {
    dispatch(ListagemArquivosActions.setShowModalDeleteFiles(false));
    handleCloseContextMenu();
  };

  const openModalDownloadMultiplesFiles = (hasFolder: boolean) => {
    if (downloadViaStream) {
      if (hasFolder) {
        return dispatch(
          ListagemArquivosActions.setShowModalDownloadMultipleFiles({
            isVisible: true,
            hasFolder: true,
          }),
        );
      } else {
        handleTrackDownloadMultiple();
        return handleDowload();
      }
    }

    if (hasFolder) {
      dispatch(
        ListagemArquivosActions.setShowModalDownloadMultipleFiles({
          isVisible: true,
          hasFolder: true,
        }),
      );
    } else {
      dispatch(
        ListagemArquivosActions.setShowModalDownloadMultipleFiles({ isVisible: true }),
      );
    }
  };

  /**
   * Qual arquivo levantou o modal de download bloqueado. O `onConfirm` chamava
   * `handleDowload()` sem argumento, que cai no `selectedEditRowKeys` — vazio
   * quando o download saiu do menu de contexto de uma linha não selecionada. O
   * pedido ia sem nenhum id e o download não acontecia.
   *
   * `null` = veio da seleção múltipla, e aí o `selectedEditRowKeys` é a fonte
   * certa mesmo.
   */
  const openModalDownloadBlockedFiles = (
    hasPermission: boolean,
    isBlocked: boolean,
    hasBlockedFolders: boolean,
    hasMultipleFiles: boolean,
    file?: IFileData | null,
  ) => {
    setDownloadBlockedFile(file ?? null);
    setBlockedParams({
      hasPermission,
      isBlocked,
      hasBlockedFolders,
      hasMultipleFiles,
    });
    setShowModalDownloadBlockedFiles(true);
  };

  const openModalVisualizationBlockedFiles = (hasPermission: boolean) => {
    dispatch(ViewerActions.setOpenFileLink(''));
    setHasPermissionVisualizationBlockedFiles(hasPermission);
    setShowModalVisualizationBlockedFiles(true);
  };

  const closeModalVisualizationBlockedFiles = () => {
    dispatch(ViewerActions.setOpenFileLink(''));
    setOpenFileVisualizationLinkStatus({} as IOpenVisualizationBlockedFileAction);
    setShowModalVisualizationBlockedFiles(false);
  };

  const openModalCriarPasta = (
    file?: IFileData,
    newFolderDestination?: string,
  ) => {
    setNewFolderWithDestination(newFolderDestination || null);
    if (file) {
      setEditFolder(file);
    } else {
      setEditFolder(null);
    }
    dispatch(ListagemArquivosActions.setShowModalCreateFolder(true));
  };

  const closeModalCriarPasta = () => {
    setNewFolderWithDestination(null);
    setEditFolder(null);
    dispatch(ListagemArquivosActions.setShowModalCreateFolder(false));
  };

  const handleDowload = (fileId?: string) => {
    if (!obra) { return; }

    const FilesId = fileId ? [fileId] : selectedEditRowKeys;
    const requestFiles: IDownloadFilesRequest = {
      api: obra.Api,
      constructionSiteId: obra.ConstructionSiteId || 0,
      itemsId: FilesId,
      constructionSiteName: obra.Name,
      tenantName: obra.TenantName,
      UserId: userInfo?.Id,
      userInfoTracking: userInfo,
      currentTenantTracking: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    };

    if (downloadViaStream) {
      toastHandler.showInfo('Seu download está em andamento...');
      const url = `${process.env.REACT_APP_BASE_DOWNLOAD_URL
        }api/Download/stream?constructionSiteId=${obra.ConstructionSiteId}&api=${obra.Api
        }&itemsIds=${FilesId.join('&itemsIds=')}`;
      window.open(url, '_blank')?.focus();
      setShowModalDownloadBlockedFiles(false);
      setDownloadBlockedFile(null);
    } else {
      dispatch(ListagemArquivosActions.downloadFiles(requestFiles));
      setShowModalDownloadBlockedFiles(false);
      setDownloadBlockedFile(null);
    }
  };

  const handleVisualizationBlockedFile = () => {
    if (openFileVisualizationLinkStatus.onConfirm) {
      openFileVisualizationLinkStatus.onConfirm();
    } else if (openFileVisualizationLinkStatus.newWindown) {
      window.open(openFileVisualizationLinkStatus.path, '_blank', 'noopener,noreferrer');
    } else {
      handleOpenFileLink(
        openFileVisualizationLinkStatus.path,
        dispatch,
        navigate,
      );
    }

    setOpenFileVisualizationLinkStatus({} as IOpenVisualizationBlockedFileAction);
    setShowModalVisualizationBlockedFiles(false);
  };

  const desarquivarArquivos = () => {
    if (!obra) { return; }

    const requestFiles: IUnarchiveFilesRequest = {
      ConstructionSiteId: obra.ConstructionSiteId || 0,
      ObsoleteFolderId: filesData?.BreadCrumbItem?.Identifier || '',
      FolderId: filesData?.BreadCrumbItem?.PreviousItem?.Identifier || '',
      FilesId: selectedEditRowKeys || [],
    };
    unarchiveFiles(requestFiles);
  };

  const createFolder = (currentFolderName: string, folderDestination?: string) => {
    if (obra && obra.ConstructionSiteId) {
      const requestFiles: ICreateFolderRequest = {
        ConstructionSiteId: obra.ConstructionSiteId,
        NewFolderName: currentFolderName,
        FolderCurrentId: folderDestination || filesData?.BreadCrumbItem?.Identifier || '',
      };
      createFolderFiles(requestFiles, {
        onSuccess: ({ data }) => {
          if (folderDestination) { return; }
          openFolder(
            obra.ConstructionSiteId || 0,
            ConstructionSiteDisciplinesId,
            data.data.Identifier.ApiId,
            obra.Api,
            filesData?.BreadCrumbItem?.BreadCrumbItemId ||
            filesData?.BreadCrumbItem?.BreadCrumbItemIdDropbox,
            false,
            data.data.Name,
            undefined,
            dispatch,
            navigate,
            DisciplineName,
          );
        },
      });
    }
  };

  const handleEditFolder = (currentFolderName: string, file: IFileData) => {
    const requestFiles: IFileRenameData = {
      ConstructionSiteId: Number(params.constructionSiteId),
      FileId: file.Identifier.ApiId,
      OldName: file.Name,
      NewName: currentFolderName,
      FolderId: filesData?.BreadCrumbItem?.Identifier || '',
      constructionSiteDisciplineId: ConstructionSiteDisciplinesId,
      IsFolder: true,
    };
    renameFiles(requestFiles);
  };

  const handleUpgradePlan = () => {
    Mixpanel.track({
      name: 'CALL_T0_ACTION',
      props: {
        origin: 'listagem-arquivos',
        originPath: window.location.pathname,
      },
      userInfo,
      currentListTenant: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    });

    if (userInfo?.CurrentRoleFk === 1) {
      navigate('/faturamento/planos');
    } else {
      window.open('https://bim.maletadoengenheiro.com.br/seja-premium');
    }
  };

  const openModalUpgradeUpload = () => {
    setShowModalUpgradeUpload(true);
  };

  const sortedListFiles = useMemo(() => {
    if (!!order.last) {
      if (order.last === 'name') {
        if (order.name === 'ascend') {
          return filesData.ListFiles.sort((a, b) => {
            return a.Name.localeCompare(b.Name);
          });
        }
        return filesData.ListFiles.sort((a, b) => {
          return b.Name.localeCompare(a.Name);
        });
      }
      if (order.last === 'extension') {
        if (order.extension === 'ascend') {
          return filesData.ListFiles.sort((a, b) => {
            return a.Extension.localeCompare(b.Extension);
          });
        }
        return filesData.ListFiles.sort((a, b) => {
          return b.Extension.localeCompare(a.Extension);
        });
      }
      if (order.last === 'sizeInBytes') {
        if (order.sizeInBytes === 'ascend') {
          return filesData.ListFiles.sort((a, b) => {
            // Unidades diferentes por API de armazenamento: sem normalizar, um
            // arquivo do Drive (MB) ordena como menor que um do Dropbox (bytes).
            return fileDataSizeToBytes(a) - fileDataSizeToBytes(b);
          });
        }
        return filesData.ListFiles.sort((a, b) => {
          return fileDataSizeToBytes(b) - fileDataSizeToBytes(a);
        });
      }
      if (order.last === 'revision') {
        if (order.revision === 'ascend') {
          return filesData.ListFiles.sort((a, b) => {
            return a.Revision ? 1 : -1;
          });
        }
        return filesData.ListFiles.sort((a, b) => {
          return b.Revision ? 1 : -1;
        });
      }
      if (order.last === 'lastUpdate') {
        if (order.lastUpdate === 'ascend') {
          return filesData.ListFiles.sort((a, b) => {
            return dayjs(a.LastUpdate).isBefore(dayjs(b.LastUpdate)) ? 1 : -1;
          });
        }
        return filesData.ListFiles.sort((a, b) => {
          return dayjs(b.LastUpdate).isBefore(dayjs(a.LastUpdate)) ? 1 : -1;
        });
      }
      if (order.last === 'status') {
        if (order.status === 'ascend') {
          return filesData.ListFiles.sort((a, b) => {
            return a.Status - b.Status;
          });
        }
        return filesData.ListFiles.sort((a, b) => {
          return b.Status - a.Status;
        });
      }
    }

    return filesData.ListFiles;
  }, [filesData.ListFiles, order]);

  const filteredListFiles = useMemo(() => {
    if (!!searchArchives && sortedListFiles.length > 0) {
      return sortedListFiles?.filter(
        (file: any) =>
          file.Name?.toLowerCase().includes(searchArchives?.toLowerCase()) ||
          file.FileInfo?.Description?.toLowerCase().includes(
            searchArchives?.toLowerCase(),
          ),
      );
    }
    return sortedListFiles;
  }, [sortedListFiles, searchArchives]);

  const moveModalCurrentBreadCrumb = useMemo(() => {
    const chain: { folderId: string; name: string }[] = [];
    let current: IBreadCrumbItem | null | undefined = filesData?.BreadCrumbItem;
    while (current) {
      chain.unshift({ folderId: current.Identifier, name: current.Name });
      current = current.PreviousItem;
    }
    return chain;
  }, [filesData?.BreadCrumbItem]);

  const handleSortListArchives = useCallback((
    key: IListFilesOrderKey,
  ) => {
    if (!key) { return; }

    setOrder((prev) => {
      if (prev[key] === null) {
        return {
          ...defaultOrder,
          [key]: 'ascend',
          last: key,
        };
      }
      if (prev[key] === 'ascend') {
        return {
          ...defaultOrder,
          [key]: 'descend',
          last: key,
        };
      }
      return {
        ...defaultOrder,
        [key]: null,
        last: null,
      };
    });
  }, []);

  const iconLeft = () => {
    const currentFolderName = folderName || filesData?.BreadCrumbItem?.Name || '';
    const matchedDiscipline = obra?.Disciplines?.find((discipline: any) => (
      (discipline.CustomName || discipline.Discipline?.Name) === currentFolderName
    ));

    if (matchedDiscipline) {
      return getDisciplineDisplayIcon(matchedDiscipline);
    }
    if (filesData?.BreadCrumbItem?.PreviousItem) {
      return 'arquivar';
    }
    return 'menuContexto';
  };

  const handleTrackDownloadMultiple = () => {
    const currentSelectedFiles = filesData.ListFiles.filter((file: any) => {
      return selectedEditRowKeys.includes(
        file.Identifier.ApiId || file.Identifier.ItemId,
      );
    });
    const hasFolder = currentSelectedFiles.some((file: any) => file.IsFolder);
    const isOnlyFolder = currentSelectedFiles.every((file: any) => file.IsFolder);

    Mixpanel.track({
      name: 'DOWNLOAD_FILE_MULTIPLO',
      props: {
        quantity: selectedEditRowKeys.length,
        api: Number(obraApi),
        constructionSiteId: Number(params.constructionSiteId),
        hasFolder,
        onlyFolder: isOnlyFolder,
        isDownloadViaStream: downloadViaStream,
      },
      userInfo,
      currentListTenant: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    });
  };

  const handleShowFollowInfoCard = () => {
    dispatch(ListagemArquivosActions.toggleShowInfoCard(true));
  };

  const handleCloseContextMenu = () => {
    contextMenuRef.current?.hide();
  };

  const handleToggleContextMenuPreventClose = (value: boolean) => {
    contextMenuRef.current?.togglePreventClose(value);
  };

  const handleToggleFollowFolder = (files: IFileData[]) => {
    const firstTimeFollowFolder = AppStorage.GetItem('FIRST_TIME_FOLLOW_FOLDER_KEY');
    if (!firstTimeFollowFolder) {
      AppStorage.SetItem('FIRST_TIME_FOLLOW_FOLDER_KEY', 'true', 'local');
      handleShowFollowInfoCard();
    }

    // TODO: Implementar a lógica de seguir pasta
    handleCloseContextMenu();
  };

  // Pede a NOSSA conversão pela listagem e acompanha pela coluna de processo —
  // o mesmo 1º clique da Autodesk, sem abrir a página. O progresso chega pelo
  // hub (eventos idênticos) e atualiza a linha do arquivo.
  const requestNativeRender = (file: IFileData) => {
    const fileApiId = file.Identifier.ApiId || file.Identifier.ItemId;
    const request = {
      constructionSiteId: Number(params.constructionSiteId),
      folderId: params.folderId || '',
      fileApiId,
    };

    setFileStatusRendering(request, nativeStatusOf(file) === BucketFileStatusEnum.Error, 'native');
    renderViewerFile(
      {
        constructionSiteId: request.constructionSiteId,
        fileApiId,
        engine: ViewerEngineEnum.Native,
      },
      {
        // No sucesso nada a fazer: sem `engine: 'native'` o backend rebaixou e a
        // Autodesk já está convertendo; a coluna acompanha do mesmo jeito, pelo hub.
        onError: (err) => {
          resetFileStatusRendering(request);
          // O backend não rebaixa sozinho: sem a escolha do usuário, nada vai
          // para a Autodesk (conversão paga).
          if (isNativeEngineUnavailableError(err)) {
            setNativeUnavailable({ file });
            return;
          }
          if (isLimitedResourcesError(err)) { setShowModalRenderUpgrade(true); }
        },
      },
    );

    Mixpanel.track({
      name: 'JOB_RENDER_FILE',
      props: {
        constructionSiteId: request.constructionSiteId,
        fileId: fileApiId,
        extension: file.Extension,
        federatedViewer: false,
        engine: 'native',
      },
      userInfo,
      currentListTenant: currentTenant,
    });
  };

  // Uma conversão por vez: o pedido do outro motor não sai, e a pessoa é avisada.
  const trackConversionBlocked = (file: IFileData, requested: ViewerEngineName) => {
    toastHandler.showInfo(i18n.t('messages:toasts.conversionInProgress'));
    Mixpanel.track({
      name: 'VIEWER_CONVERSION_BLOCKED',
      props: { requested, at: 'list', extension: file.Extension, sizeInBytes: file.SizeInBytes },
      userInfo,
      currentListTenant: currentTenant,
    });
  };

  const handleOpenFile = async (
    fileToOpen: IFileData | null,
    event: number,
    options?: IOpenFileOptions,
  ) => {
    if (!fileToOpen) { return; }
    let file: IFileData = fileToOpen;

    // Nova guia: o mesmo fluxo de decisão (3D, 2D, Autodesk, arquivo bloqueado),
    // só o destino muda. Troca-se o `navigate` num ponto só em vez de duplicar
    // cada caminho.
    const go: NavigateFunction = options?.newTab
      ? ((to: To) => { window.open(typeof to === 'string' ? to : createPath(to), '_blank', 'noopener,noreferrer'); }) as NavigateFunction
      : navigate;
    const setBlockedLink: typeof setOpenFileVisualizationLinkStatus = options?.newTab
      ? (value) => setOpenFileVisualizationLinkStatus((current) => {
        const next = typeof value === 'function' ? value(current) : value;
        return { ...next, newWindown: true };
      })
      : setOpenFileVisualizationLinkStatus;

    // Os viewers internos passam pelo mesmo aviso de arquivo bloqueado do fluxo
    // Autodesk (`handleOpenForgeViewer`); sem isso o bloqueado abria direto.
    const openUnlessBlocked = (path: string, open: () => void) => {
      if (file.Status !== 0 || options?.blockedAccepted) { open(); return; }
      if (AccessPermission.isEngOrConsult()) { openModalVisualizationBlockedFiles(false); return; }
      setBlockedLink({ path, newWindown: false, onConfirm: open });
      openModalVisualizationBlockedFiles(true);
    };

    if (file.IsFolder) {
      if (options?.newTab) {
        openFolder(
          Number(params.constructionSiteId),
          ConstructionSiteDisciplinesId,
          file.Identifier.ApiId,
          obra?.Api,
          filesData?.BreadCrumbItem?.BreadCrumbItemId || filesData?.BreadCrumbItem?.BreadCrumbItemIdDropbox,
          false,
          file.Name,
          undefined,
          dispatch,
          go,
          DisciplineName,
        );
      }
      return handleCloseContextMenu();
    }

    if (options?.forceAutodesk && file.Extension?.toLocaleLowerCase() === COORDLY_3D_VIEWER_EXTENSION) {
      Mixpanel.track({
        name: 'COORDLY_3D_VIEWER_FALLBACK',
        props: { reason: 'user-choice', at: 'list', sizeInBytes: file.SizeInBytes, hasNativeRender: isNativeReady(file) },
        userInfo,
        currentListTenant: currentTenant,
      });
    }

    // Só IFC entra aqui; qualquer reprovação do gate segue o fluxo normal abaixo
    // (Autodesk), que dispara o job de conversão sozinho. `forceAutodesk` é o
    // usuário pedindo o Autodesk de propósito — pula o gate inteiro.
    if (!options?.forceAutodesk && file.Extension?.toLocaleLowerCase() === COORDLY_3D_VIEWER_EXTENSION) {
      // Clique direito não abre o arquivo: só publica o link, que vira o `href` do
      // nome (abrir em nova aba) e deixa o menu de contexto subir. O guard precisa
      // ser síncrono — depois do `await` abaixo ele já rodaria fora do handler do
      // evento e fecharia o menu que o bubbling acabou de abrir.
      const nativeReady = isNativeReady(file);
      if (event === 2 && isCoordly3DViewerEligible(file.Extension, nativeReady)) {
        const breadCrumbId = filesData?.BreadCrumbItem?.BreadCrumbItemId || filesData?.BreadCrumbItem?.BreadCrumbItemIdDropbox;
        dispatch(ViewerActions.setOpenFileLink(getCoordly3DViewerPath(file, breadCrumbId)));
        return handleCloseContextMenu();
      }

      // Com a flag desligada só o já convertido passa: os ramos de pedir render
      // abaixo ficam restritos a quem tem a flag.
      const decision = await decideCoordly3D({ extension: file.Extension, hasNativeRender: nativeReady });

      if (decision.target !== 'autodesk') {
        const breadCrumbId = filesData?.BreadCrumbItem?.BreadCrumbItemId || filesData?.BreadCrumbItem?.BreadCrumbItemIdDropbox;
        const etapa = file.RenderingSignalR?.etapa;


        // Convertido no nativo abre direto; em nova guia, abre sempre — a rota
        // pede a conversão nativa lá.
        const open3D = () => openUnlessBlocked(
          getCoordly3DViewerPath(file, breadCrumbId),
          () => handleOpenCoordly3DViewer(go, file, breadCrumbId),
        );

        if (nativeReady || options?.newTab) {
          open3D();
          return handleCloseContextMenu();
        }

        // Uma conversão por vez: com a da Autodesk andando, a nativa não sai.
        if (autodeskStatusOf(file) === BucketFileStatusEnum.Rendering) {
          trackConversionBlocked(file, 'native');
          return handleCloseContextMenu();
        }

        // Em processamento: como na Autodesk, o 1º clique já pediu e a coluna
        // mostra o andamento; insistir com o processo andando abre a página,
        // que acompanha também. Sem evento nesta sessão (ex.: depois de um
        // refresh) não há `etapa` e a página já pode abrir.
        if (file.RenderingStatus === 2) {
          if (etapa === undefined || etapa > 0) { open3D(); }
          return handleCloseContextMenu();
        }

        // Sem conversão nativa (nunca convertido, só Autodesk ou erro): pede a
        // nossa daqui, sem abrir a página — bloqueado passa antes pelo aviso.
        openUnlessBlocked(getCoordly3DViewerPath(file, breadCrumbId), () => requestNativeRender(file));
        return handleCloseContextMenu();
      }

      Mixpanel.track({
        name: 'COORDLY_3D_VIEWER_FALLBACK',
        props: {
          reason: decision.reason,
          at: 'list',
          sizeInBytes: file.SizeInBytes,
        },
        userInfo,
        currentListTenant: currentTenant,
      });
    }

    // Daqui para baixo é o fluxo da Autodesk (e o 2D, que não converte): a linha
    // passa a mostrar só a conversão dela. Uma conversão por vez: com a nativa
    // andando, a da Autodesk não sai.
    if (event !== 2 && nativeStatusOf(file) === BucketFileStatusEnum.Rendering) {
      trackConversionBlocked(file, 'autodesk');
      return handleCloseContextMenu();
    }
    file = asAutodeskConversion(file);

    if (isCoordly2DViewerEligible(file.Extension)) {
      const breadCrumbId = filesData?.BreadCrumbItem?.BreadCrumbItemId || filesData?.BreadCrumbItem?.BreadCrumbItemIdDropbox;
      if (event === 2) {
        dispatch(ViewerActions.setOpenFileLink(getCoordly2DViewerPath(file, breadCrumbId)));
        return handleCloseContextMenu();
      }
      openUnlessBlocked(
        getCoordly2DViewerPath(file, breadCrumbId),
        () => handleOpenCoordly2DViewer(go, file, breadCrumbId),
      );
      return handleCloseContextMenu();
    }

    // Não convertido em nova guia: a conversão acontece lá, e a tela do
    // Autodesk pede o aceite antes de gastar crédito.
    if (
      (event === 2 || options?.newTab) &&
      (extensions2dAnd3d.indexOf(file.Extension.toLocaleLowerCase()) !== -1) &&
      (file.RenderingStatus === null || file.RenderingStatus === 0)
    ) {
      const path = getAutodeskViewerPath({
        csId: Number(params.constructionSiteId),
        folderId: params.folderId || file.FileInfo.ApiFolderId,
        apiId: file.FileInfo?.ApiId || file.Identifier?.ApiId,
        breadCrumbId: filesData?.BreadCrumbItem?.BreadCrumbItemId || filesData?.BreadCrumbItem?.BreadCrumbItemIdDropbox || '',
        constructionSiteApiId: obra?.Api || 0,
        ConstructionSiteDisciplinesId,
      });
      if (event === 2) {
        // Bloqueado não ganha link: passa pelo aviso ao escolher "Abrir".
        dispatch(ViewerActions.setOpenFileLink(file.Status === 0 ? '' : path));
        return handleCloseContextMenu();
      }
      // Pelo nosso menu dá para perguntar aqui, antes da guia: aviso de
      // bloqueado e depois o aceite do gasto (a guia nova não pergunta de novo).
      const apiId = file.FileInfo?.ApiId || file.Identifier?.ApiId || '';
      const openTab = () => {
        markAutodeskConversionConfirmed(apiId);
        window.open(path, '_blank', 'noopener,noreferrer');
      };
      openUnlessBlocked(path, () => { void confirmAutodeskConversion(file, openTab, options?.conversionAccepted); });
      return handleCloseContextMenu();
    }

    // Clique que converte aqui mesmo: bloqueado passa antes pelo aviso, e a
    // conversão pelo aceite do gasto.
    if (
      file.Status === 0 && !options?.blockedAccepted &&
      (extensions2dAnd3d.indexOf(file.Extension.toLocaleLowerCase()) !== -1) &&
      (file.RenderingStatus === null || file.RenderingStatus === 0 || file.RenderingStatus === 3)
    ) {
      openUnlessBlocked('', () => { void handleOpenFile(file, event, { ...options, blockedAccepted: true }); });
      return handleCloseContextMenu();
    }

    const tenantIds = tenants && tenants.length > 0
      ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
      : undefined;

    const openForge = () => handleOpenForgeViewer({
      csId: Number(params.constructionSiteId),
      folderId: params.folderId || '',
      ConstructionSiteDisciplinesId,
      record: file,
      breadCrumbId: filesData?.BreadCrumbItem?.BreadCrumbItemId || filesData?.BreadCrumbItem?.BreadCrumbItemIdDropbox || '',
      constructionSiteApiId: obra?.Api || 0,
      mouseClickEvent: event,
      userInfo,
      currentTenant,
      tenantIds,
      disciplineName: DisciplineName,
      dispatch,
      navigate: go,
      openModalVisualizationBlockedFiles,
      setOpenFileVisualizationLinkStatus: setBlockedLink,
      openModalRenderUpgrade: () => setShowModalRenderUpgrade(true),
    });

    // A nova tentativa de uma conversão com erro também gasta crédito.
    if (
      (extensions2dAnd3d.indexOf(file.Extension.toLocaleLowerCase()) !== -1) &&
      (file.RenderingStatus === null || file.RenderingStatus === 0 || (file.RenderingStatus === 3 && event !== 2))
    ) {
      void confirmAutodeskConversion(file, openForge, options?.conversionAccepted);
    } else {
      openForge();
    }

    return handleCloseContextMenu();
  };

  const handleDownloadFile = (file: IFileData | null) => {
    if (!file || file.IsFolder) { return; }

    const isBlocked = file.Status === 0;
    if (
      openModalDownloadBlockedFiles &&
      AccessPermission.downloadSelectBlockedFiles(filesData.ListFiles, currentUserPrivileges) &&
      isBlocked
    ) {
      openModalDownloadBlockedFiles(true, false, false, false, file);
      return handleCloseContextMenu();
    }
    if (
      openModalDownloadBlockedFiles &&
      !AccessPermission.downloadSelectBlockedFiles(filesData.ListFiles, currentUserPrivileges) &&
      AccessPermission.isEngOrConsult()
    ) {
      openModalDownloadBlockedFiles(false, true, false, false, file);
      return handleCloseContextMenu();
    }
    handleDowload(file.Identifier.ApiId);
    return handleCloseContextMenu();
  };

  const handleEditFile = (file: IFileData | null) => {
    if (!file) { return; }

    if (file.IsFolder) {
      openModalCriarPasta(file);
      return handleCloseContextMenu();
    }

    setActiveRow([file.Identifier.ApiId]);
    return handleCloseContextMenu();
  };

  const handleChangeStatusFile = (
    file: IFileData | null,
    status: FileStatusEnum,
    onClose: () => void,
  ) => {
    if (!file || file.IsFolder) { return; }

    changeStatusFiles(
      [file.Identifier.ApiId],
      filesData.ListFiles,
      Number(params.constructionSiteId),
      params.folderId || '',
      status,
      updateFilesStatus,
      onClose,
    );
    return handleCloseContextMenu();
  };

  const handleOpenHistoryDrawer = (fileData?: IFileData | null) => {
    let title = 'Histórico de Pasta';
    let parentName = filesData.BreadCrumbItem?.Name;
    let itemId = filesData.BreadCrumbItem?.Identifier;
    let isFolder = true;

    if (selectedEditRowKeys.length === 0 && !fileData) {
      if (!filesData.BreadCrumbItem?.PreviousItem) {
        title = 'Histórico de Disciplina';
      } else {
        title = 'Histórico de Pasta';
      }
    }

    if (selectedEditRowKeys.length === 1 || fileData) {
      if (fileData) {
        if (!fileData.IsFolder) {
          title = 'Histórico de Arquivo';
          isFolder = false;
        }
        parentName = fileData.Name;
        itemId = fileData.Identifier.ApiId;
      }

      if (!fileData) {
        const fileIndex = filesData.ListFiles.findIndex((file: any) => {
          return file.Identifier.ApiId === selectedEditRowKeys[0];
        });
        if (fileIndex !== -1) {
          if (!filesData.ListFiles[fileIndex].IsFolder) {
            title = 'Histórico de Arquivo';
            isFolder = false;
          }
          parentName = filesData.ListFiles[fileIndex].Name;
          itemId = filesData.ListFiles[fileIndex].Identifier.ApiId;
        }
      }
    }

    handleCloseContextMenu();
    const requestFile: IHistoryFileRequestList = {
      title,
      parentName: parentName || '',
      itemId: itemId || '',
      isFolder,
    };
    dispatch(HistoryActions.listHistoryFileRequest(requestFile));
  };

  const handleRefetchFiles = () => {
    setDynamicIgnoreCache(true);
    clear('REFETCH_FILES_DATA');
    set('REFETCH_FILES_DATA', () => {
      refetchFilesData();
    }, 200);
  };

  if (showPlotRequestTable) {
    return (
      <SolicitacaoPlotagem
        constructionSiteId={Number(params.constructionSiteId)}
        requestPlotListFiles={requestPlotListFiles}
        breadcrumbs={breadCrumbs}
      />
    );
  }

  return (
    <>
      <ViewerSignalR
        constructionSiteId={Number(params.constructionSiteId)}
        folderId={params.folderId || ''}
      />
      <TabsShell
        ConstructionSiteId={params.constructionSiteId}
        active={PathActiveEnum.detail}
        loading={isLoadingFileList}
      />
      <PageHeader
        name={folderName || filesData?.BreadCrumbItem?.Name || ''}
        iconLeft={iconLeft()}
      >
        <div className={styles['headerBreadcrumb']}>
          <BreadCrumb breadcrumbs={breadCrumbs} />
          <UpdateStatus
            status={filesData.LastUpdate?.status}
            date={filesData.LastUpdate?.lastUpdate}
            loading={isLoading}
          />
        </div>
        <div className={styles['tableContainer']}>
          {isObsoleteFolder && !selectedEditRowKeys.length ? (
            <TableActionTopbar
              buttons={[]}
              onSearch={setSearchArchives}
              onSearchLoading={setSearchLoading}
              inputPlaceholder='Pesquise por um arquivo'
            />
          ) : (
            <TableActionTopbar
              buttons={
                !isLoadingFileList
                  ? getButtonsTableToolbar({
                    preferencesFeature: followFolderFeature,
                    listFiles: filesData.ListFiles,
                    ConstructionSiteDisciplinesId,
                    obra: obra as IObraResponse,
                    selectedRowKeys: selectedEditRowKeys,
                    selectedFiles,
                    showEditTable,
                    breadCrumbItemId:
                      filesData?.BreadCrumbItem?.BreadCrumbItemId ||
                      filesData?.BreadCrumbItem?.BreadCrumbItemIdDropbox,
                    isDownloading,
                    isObsoleteFolder,
                    ObsoleteFolderId: filesData.ObsoleteFolderId,
                    constructionSiteId: request.constructionSiteId,
                    folderId: request.folderId,
                    folderName: request.folderName,
                    disciplineName: DisciplineName,
                    platform: obra?.Api || 0,
                    urlFolder: filesData.CloudServiceFolderUrl,
                    breadCrumbPreviousItemId: breadCrumbId,
                    planIsFree: planFree,
                    isLoadingFilesObsoleteList: isLoadingFileList,
                    currentUserPrivileges,
                    userInfo,
                    currentTenant,
                    tenantIds:
                      tenants && tenants.length > 0
                        ? (tenants
                          ?.map((tenant) => tenant?.TenantId)
                          .filter((tenantId) => tenantId !== undefined) as number[])
                        : undefined,
                    flags: { downloadViaStream },
                    dispatch,
                    updateFileInfo: updateInfoFiles,
                    updateFilesStatus,
                    navigate,
                    openModalExclusaoArquivos,
                    openModalDownloadMultiplesFiles,
                    openModalDownloadBlockedFiles,
                    onDownload: () => handleDowload(),
                    desarquivarArquivos,
                    openModalCriarPasta,
                    onOpenHistoryDrawer: handleOpenHistoryDrawer,
                    onToggleFollowFolder: handleToggleFollowFolder,
                    onOpenModalMoveFiles: () => setShowMoveFilesModal(true),
                    onRefetchFiles: handleRefetchFiles,
                    resetResizableColumns,
                  })
                  : []
              }
              searchDelay={0}
              onSearch={setSearchArchives}
              onSearchLoading={setSearchLoading}
              inputPlaceholder='Pesquise por um arquivo'
            />
          )}
          {isLoadingFileList ? (
            <LoadingArchives multiple={11} />
          ) : filesData.ListFiles.length ? (
            showEditTable ? (
              <ConfigProvider
                renderEmpty={() =>
                  searchArchives ? (
                    <CustomEmptyData
                      title='Nenhum arquivo encontrado'
                      subtitle='Tente pesquisar pelo nome ou descrição do arquivo.'
                    />
                  ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  )
                }
              >
                <Table
                  className={styles['editTable']}
                  dataSource={filteredListFiles
                    .filter(
                      (file: any) =>
                        !file.IsFolder &&
                        (!selectedEditRowKeys.length ||
                          selectedEditRowKeys.includes(
                            file.Identifier.ApiId || file.Identifier.ItemId,
                          )),
                    )
                    .map((fileData: any, index: number) => ({ ...fileData, key: index }))}
                  columns={getColumnsTableEdit({
                    onSubmit,
                    nomenclature,
                    isLoadingRenameFile,
                    editFormIndex,
                    dispatch,
                    obra: obra as IObraResponse,
                    isStageValidation: stagesFeatureValidate,
                    constructionSiteDisciplinesId: ConstructionSiteDisciplinesId,
                  })}
                />
              </ConfigProvider>
            ) : (
              <FileDrop
                dragInfo={filesData?.BreadCrumbItem?.Name}
                onDropFiles={(files) =>
                  updateUploadState(
                    files,
                    params,
                    obra as IObraResponse,
                    filesData?.BreadCrumbItem || ({} as IBreadCrumbItem),
                    dispatch,
                    ConstructionSiteDisciplinesId,
                    userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                    userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles,
                    openModalUpgradeUpload,
                    folderName,
                    DisciplineName,
                  )
                }
                maxQtyUploadFiles={
                  userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                  userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
                }
                limitUpload={
                  userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                  userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
                }
              >
                <ConfigProvider
                  renderEmpty={() =>
                    searchArchives ? (
                      <CustomEmptyData
                        title='Nenhum arquivo encontrado'
                        subtitle='Tente pesquisar pelo nome ou descrição do arquivo.'
                      />
                    ) : (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )
                  }
                >
                  <Table
                    virtual
                    scroll={{ x: scrollX, y: tableHeight }}
                    className={styles['listTable']}
                    columns={getColumnsTable({
                      columnsWidth: displayColumnsWidth,
                      fileList: filesData.ListFiles,
                      filters,
                      constructionSiteId: obra?.ConstructionSiteId || 0,
                      folderId: params.folderId || '',
                      breadCrumbItem:
                        filesData?.BreadCrumbItem || ({} as IBreadCrumbItem),
                      constructionSiteApiId: obra?.Api || 0,
                      ConstructionSiteDisciplinesId,
                      itemsNotification: filterNotification,
                      itemIdNotification: itemIdNotification,
                      planFree: planFree,
                      disciplineName: DisciplineName,
                      activeRow,
                      isLoadingRenameFile,
                      openLink,
                      isCoordly2DViewerEligible,
                      isCoordly3DViewerEligible,
                      isLoadingFilesObsoleteList: isLoadingFileList,
                      currentUserPrivileges,
                      isObsoleteFolder,
                      notificationsObj,
                      openMoreActionsDropdown,
                      preferencesFeature: followFolderFeature,
                      order,
                      breadCrumbPreviousItemId:
                        filesData?.BreadCrumbItem?.PreviousItem?.Identifier || null,
                      dispatch,
                      navigate,
                      onChangeNomenclatureInList,
                      onOpenHistoryDrawer: handleOpenHistoryDrawer,
                      onOpenMoreActionsDropdown: handleOpenMoreActionsDropdown,
                      onCloseMoreActionsDropdown: handleCloseMoreActionsDropdown,
                      onContextMenu: handleContextMenu,
                      onToggleContextMenuPreventClose: handleToggleContextMenuPreventClose,
                      onOpenFile: handleOpenFile,
                      onToggleFollowFolder: handleToggleFollowFolder,
                      onDownloadFile: handleDownloadFile,
                      onEditFile: handleEditFile,
                      onChangeStatusFile: handleChangeStatusFile,
                      onOpenModalExclusaoArquivos: openModalExclusaoArquivos,
                      onSortList: handleSortListArchives,
                      onResize: handleResize,
                    })}
                    dataSource={filteredListFiles?.map(
                      (fileData: any, index: number) => ({
                        ...fileData,
                        key: index,
                      }),
                    )}
                    rowClassName={styles['file-list-row']}
                    expandable={{
                      expandIcon: () => false,
                      expandedRowKeys: activeRow,
                      expandedRowRender: (record, index) => {
                        if (!record.IsFolder && record.FileInfo) {
                          if (stagesFeatureValidate) {
                            return (
                              <NewEdicaoNomenclatura
                                record={record}
                                nomenclature={nomenclature}
                                obra={obra as IObraResponse}
                                constructionSiteDisciplinesId={
                                  ConstructionSiteDisciplinesId
                                }
                                isLoadingRenameFile={isLoadingRenameFile}
                                text={record.Name}
                                islistEdit
                                index={index}
                                onSubmit={onSubmit}
                                onCancel={() => setActiveRow([])}
                              />
                            );
                          }
                          return (
                            <EdicaoNomenclatura
                              record={record}
                              nomenclature={nomenclature}
                              obra={obra as IObraResponse}
                              onSubmit={onSubmit}
                              isLoadingRenameFile={isLoadingRenameFile}
                              text={record.Name}
                              islistEdit
                              onCancel={() => setActiveRow([])}
                              index={index}
                            />
                          );
                        }
                        return null;
                      },
                    }}
                    rowKey={(record: any) =>
                      record.Identifier.ApiId || record.Identifier.ItemId
                    }
                    rowSelection={rowSelection}
                  />
                </ConfigProvider>
              </FileDrop>
            )
          ) : (
            <FileDrop
              dragInfo={filesData?.BreadCrumbItem?.Name}
              onDropFiles={(files) =>
                updateUploadState(
                  files,
                  params,
                  obra as IObraResponse,
                  filesData?.BreadCrumbItem || ({} as IBreadCrumbItem),
                  dispatch,
                  ConstructionSiteDisciplinesId,
                  userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                  userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles,
                  openModalUpgradeUpload,
                  folderName,
                  DisciplineName,
                )
              }
              maxQtyUploadFiles={
                userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
              }
              limitUpload={
                userInfo?.UserStoreItem.MaxQtyUploadFiles ||
                userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
              }
            >
              <div className={styles['emptyListWrap']}>
                <img src={emptyListImage} alt='Pasta vazia' />
                <span className={styles['title']}>
                  Você ainda não possui arquivos nesta pasta, arraste para fazer upload
                </span>
              </div>
            </FileDrop>
          )}
        </div>
        {showModalInfoFiles && (
          <AvisoTamanhoEQuantidadeArquivos
            visible={showModalInfoFiles}
            onConfirm={() =>
              dispatch(ListagemArquivosActions.setShowModalInfoFiles(false))
            }
          />
        )}
        {showModalDeleteFiles && (
          <ExclusaoArquivos
            isLoading={isLoading}
            visible={showModalDeleteFiles}
            deleteFilesRequest={deleteFilesRequest}
            onClearSelectedFiles={handleClearSelectedFiles}
            onCancel={closeModalExclusaoArquivos}
          />
        )}
        {showModalCreateFolder && (
          <NovaPasta
            isLoading={isLoadingCreateFolder || isLoadingRenameFile}
            visible={showModalCreateFolder}
            file={editFolder}
            newFolderDestination={newFolderWithDestination}
            onCancel={closeModalCriarPasta}
            onCreate={createFolder}
            onEdit={handleEditFolder}
          />
        )}
        {nativeUnavailable && (
          <ViewerNativoIndisponivelModal
            visible
            noWebGPU={nativeUnavailable.noWebGPU}
            onClose={() => setNativeUnavailable(null)}
            onConfirm={() => {
              const { file, newTab } = nativeUnavailable;
              setNativeUnavailable(null);
              void handleOpenFile(file, 0, { forceAutodesk: true, newTab, conversionAccepted: true });
            }}
          />
        )}
        {confirmAutodesk && (
          <ProgressRenderBar
            visible
            {...renderQuotaBar(confirmAutodesk.quota)}
            role={userInfo?.CurrentRoleFk}
            onCancel={() => setConfirmAutodesk(null)}
            onConfirmRender={confirmAutodesk.onConfirm}
          />
        )}
        {showModalRenderUpgrade && (
          <AvisoRenderizacaoUpgrade
            visible={showModalRenderUpgrade}
            onCancel={() => setShowModalRenderUpgrade(false)}
          />
        )}
        {showModalVisualizationBlockedFiles && (
          <VisualizacaoBloqueadosModal
            visible={showModalVisualizationBlockedFiles}
            onClose={() => closeModalVisualizationBlockedFiles()}
            onConfirm={() => handleVisualizationBlockedFile()}
            hasPermission={hasPermissionVisualizationBlockedFiles}
          />
        )}
        {showModalUpgradeUpload && (
          <AvisoUploadUpgrade
            visible={showModalUpgradeUpload}
            onCancel={() => setShowModalUpgradeUpload(false)}
            role={userInfo?.CurrentRoleFk}
            planFree={planFree}
            onConfirm={handleUpgradePlan}
            limitUpload={
              userInfo?.UserStoreItem.MaxQtyUploadFiles ||
              userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles
            }
          />
        )}
        <input
          id='uploadFiles'
          type='file'
          hidden
          multiple
          onChange={(e) => {
            updateUploadState(
              e.currentTarget.files,
              params,
              obra as IObraResponse,
              filesData?.BreadCrumbItem || ({} as IBreadCrumbItem),
              dispatch,
              ConstructionSiteDisciplinesId,
              userInfo?.UserStoreItem.MaxQtyUploadFiles ||
              userInfo?.UserStoreItem.StorePlan?.MaxQtyUploadFiles,
              openModalUpgradeUpload,
              folderName,
              DisciplineName,
            );
            e.currentTarget.value = '';
          }}
        />
        <DownloadModal
          platform={obra?.Api || 0}
          urlFolder={filesData?.CloudServiceFolderUrl}
          onTrackDownloadMultiple={handleTrackDownloadMultiple}
        />
        {showModalDownloadBlockedFiles && (
          <DownloadBloqueadosModal
            visible={showModalDownloadBlockedFiles}
            blockedParams={blockedParams}
            onClose={() => {
              setShowModalDownloadBlockedFiles(false);
              setDownloadBlockedFile(null);
            }}
            onConfirm={() => handleDowload(downloadBlockedFile?.Identifier?.ApiId)}
          />
        )}
        {showMoveFilesModal && (
          <MoveFilesModal
            visible={showMoveFilesModal}
            files={selectedFiles}
            constructionSiteId={Number(params.constructionSiteId)}
            oldFolderId={params.folderId}
            currentDisciplineId={ConstructionSiteDisciplinesId}
            currentBreadCrumb={moveModalCurrentBreadCrumb}
            onCancel={() => setShowMoveFilesModal(false)}
            onNewFolder={openModalCriarPasta}
          />
        )}

        <ContextMenu ref={contextMenuRef} id={menuId} menuHeight={225} menuWidth={208}>
          <MoreActionsDropdownContent
            record={contextMenuRecord}
            folderId={params.folderId}
            breadCrumbPreviousItemId={breadCrumbId}
            canFollowFolder={followFolderFeature}
            onToggleContextMenuPreventClose={handleToggleContextMenuPreventClose}
            onOpenFile={handleOpenFile}
            onToggleFollowFolder={handleToggleFollowFolder}
            onDownloadFile={handleDownloadFile}
            onEditFile={handleEditFile}
            onChangeStatusFile={handleChangeStatusFile}
            onOpenHistoryDrawer={handleOpenHistoryDrawer}
            onOpenModalExclusaoArquivos={openModalExclusaoArquivos}
            onCloseMoreActionsDropdown={handleCloseMoreActionsDropdown}
          />
        </ContextMenu>
      </PageHeader>
    </>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.listagemArquivos,
  ...state.auth,
  isLoading: state.listagemArquivos.isLoading,
  TenantUsers: state.tenant.TenantUsers,
  nomenclature: state.nomenclatura.NomenclatureData,
  notificationsMapOld: state.notification.notificationsMap,
  openLink: state.viewer.openFileLink,
  isShellCollapsed: state.obra.isCollapsed,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(ListagemArquivos);
